import { render, staticRenderFns } from "./UploadQuestion.vue?vue&type=template&id=c7ed2ae4&lang=true&"
import script from "./UploadQuestion.vue?vue&type=script&lang=js&"
export * from "./UploadQuestion.vue?vue&type=script&lang=js&"
import style0 from "./UploadQuestion.vue?vue&type=style&index=0&id=c7ed2ae4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports